export enum GroupUserRolesType {
  MENTOR = 'MENTOR',
  MENTEE = 'MENTEE',
  MANAGER = 'MANAGER',
}

export enum ProgramUserRolesType {
  GUEST = 'GUEST',
  MENTOR = 'MENTOR',
  MENTEE = 'MENTEE',
  ADMIN = 'ADMIN',
  MANAGER = 'MANAGER',
  SUPPORT = 'SUPPORT',
}

export enum RoleEnumTypeV2 {
  GUEST = 'GUEST',
  MENTOR = 'MENTOR',
  MENTEE = 'MENTEE',
  ADMIN = 'ADMIN',
  MANAGER = 'MANAGER',
  SUPPORT = 'SUPPORT',
}

export enum PermissionsGroupsEnumType {
  ADMIN = 'ADMIN',
  USER = 'USER',
}

export type V1AccountDataType = {
  id: string
  createdAt: string
  language: string
  identity?: {
    firstname: string
    lastname: string
    userId: string
  }
  personalInformation?: { profilPicture: string }
}

export type V2AccountDataType = {
  id: string
  supportId: string
  createdAt: string
  firstName: string
  lastName: string
  picture: string
  email: string
  hasSAML: boolean
  hasAcceptedTerms: boolean
  /** KC-537 : true si la modale correspond à une ré-acceptation après mise à jour des documents */
  termsReacceptance: boolean
  /** KC-526 : date de la dernière acceptation complète des documents légaux (null si pas à jour) */
  termsAcceptedAt: string | null
  /** KC-526 : versions courantes des documents légaux (dates ISO), pour affichage dans le profil */
  legalDocVersions: { cgu: string; privacy: string } | null
  language: string
  mfaEnabled: boolean
  /** Compte de l'équipe Constel (adresse @constel-education.com) : sert à l'affichage, l'API vérifie de son côté */
  isConstelStaff: boolean
}

export type V1AuthUserType = {
  email: string
  id: string
  samlId: string
  supportId: string
  cguAccepted: boolean
  termsUpToDate?: boolean
  termsReacceptance?: boolean
  termsAcceptedAt?: string | null
  legalDocVersions?: { cgu: string; privacy: string }
  language: string
  mfaEnabled?: boolean
}

export type V1ChangePasswordDTOType = {
  userId: string
  confirmPassword: string
  password: string
  oldPassword: string
}

export type V1PhoneType = {
  country: string
  number: string
  prefix: string
  id: string
  userId: string
}

export type LoginDTOType = {
  email: string
  password: string
}

export type LoginResponseType = {
  token: string
  user: {
    id: string
    email: string
    samlId: string
    language: string
  }
  isFirstLogin?: boolean // KC-439 : première connexion réussie de l'utilisateur
  error?: string // if there is an error during login process
}

export type ResetPasswordDTOType = {
  token: string
  password: string
  confirmPassword: string
}

export type RegisterDTOType = {
  cguAccepted: boolean
  email: string
  password: string
}

export type V1UpdateUserDTOType = Partial<{
  email: string
  // firstName: string
  // lastName: string
  // phone: string
  // picture: File
  // language: string
}>

export type UpdateUserDescriptionDTOType = {
  userId: string
  description: string
}

export type UpdateUserDTOType = Partial<{
  userId: string
  email: string
  firstName: string
  lastName: string
  phone: string
  picture: File
  language: string
}>

export type V1UpdateUserIdentityDTOType = {
  firstname: string
  lastname: string
}

export type V1UpdatePhoneDTOType = {
  phone: string
  userId: string
}

export type V1UpdateLanguageDTOType = {
  language: string
}

export type V1UpdateUserPictureDTOType = FormData

export type DoesUserExistDTOType = {
  email: string
}

export type DoesUserExistResponseType = {
  isExist: boolean
  userId: string
}

/** Méthode de connexion d'une adresse (parcours « adresse d'abord »). */
export type LoginMethodType = 'sso' | 'password' | 'not_found'

export type LoginMethodResponseType = {
  method: LoginMethodType
}

export type MfaSetupResponseType = {
  secret: string
  qrCode: string
  manualEntryKey: string
  backupCodes: string[]
}

export type MfaEnableDTOType = {
  code: string
}

export type MfaDisableDTOType = {
  password: string
  code: string
}

export type MfaVerifyDTOType = {
  email: string
  code: string
}

export type MfaVerifyResponseType = {
  token: string
  isFirstLogin?: boolean // KC-439 : première connexion réussie de l'utilisateur
  user: {
    id: string
    email: string
    language: string
  }
}
